
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30948',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30948",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55524",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8465",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11919",
  "I18n": "static-7.1696",
  "quartz": "static-1.7600",
  "quartz-config": "static-1.1378",
  "quartz-core": "static-1.6819",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1049",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55511",
  "feedback-utils": "static-1.55515",
  "forms-embed-utils-lib": "static-1.4890",
  "forms-utils-lib": "static-1.13263",
  "foundations-assets": "static-1.5312",
  "foundations-components": "static-1.8674",
  "foundations-theming": "static-1.4909",
  "hub-http": "static-1.6636",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12226",
  "icons": "static-2.699",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4200",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17160",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5632",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.514",
  "tinymce-plugins": "static-1.58430",
  "transmute": "static-2.97",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8865",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3877",
  "quartz-webpack": "static-1.3824",
  "foundations-theming-specialty": "static-1.2625",
  "property-description-translator": "static-1.4247",
  "HeadJS": "static-2.815",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3576",
  "msw": "static-1.102",
  "msw-config": "static-1.23",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4735",
  "jasmine-runner": "static-1.6877",
  "opentelemetry-fe-types": "static-1.214",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.900",
  "hubspotter-http": "static-1.4940",
  "mobile-manifest-mixins": "static-1.598",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.589",
  "quartz-auth": "static-1.1275",
  "quartz-head": "static-1.1265",
  "quartz-i18n": "static-1.1275",
  "quartz-routing": "static-1.1030",
  "quartz-test": "static-1.1275",
  "quartz-tracking": "static-1.979",
  "trellis-components": "static-1-rdeane_hubspot-tooltip-trigger-canary.14",
  "ui-fonts": "static-1.1181",
  "usage-tracker-container": "static-1.7731",
  "usage-tracker-core": "static-1.7591",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.315",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8604",
  "sanitize-text": "static-1.8583",
  "PatternValidationJS": "static-1.3313",
  "ReduxMessenger": "static-2.10798",
  "outpost": "static-1.4560",
  "rpc-client-utils": "static-1.5097",
  "sanitize": "static-1.4900",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4943",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9851",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.94",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1-rdeane_hubspot-tooltip-trigger-canary.14",
  "bend-plugin-foundations-theming": "static-1.3392",
  "foundations-theming-base": "static-1.3894",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.370",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9941",
  "atom": "static-1.5504",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8355",
  "ContentUtils": "static-1.69364",
  "data-token-picker": "static-1.17056",
  "file-manager-components": "static-1.24759",
  "FileManagerCore": "static-1.40258",
  "FileManagerLib": "static-1.40399",
  "frontend-preferences-client": "static-1.8345",
  "hub-http-contrib": "static-1.3455",
  "interframe": "static-3.5167",
  "layout-dnd-components": "static-1.13146",
  "layout-dnd-utils": "static-1.12121",
  "property-translator": "static-1.5806",
  "react-codemirror": "static-1.11067",
  "react-colorpicker": "static-2.10639",
  "reference-resolvers-lite": "static-1.8533",
  "rich-text-lib": "static-1.20484",
  "tinymce-data": "static-1.41401",
  "tinymce-themes": "static-1.57286",
  "ui-addon-emoji-picker": "static-1.10293",
  "ui-addon-sales-email": "static-1.5629",
  "ui-brand-identity-lib": "static-1.16818",
  "bender-build-tools": "static-1.3518",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1412",
  "tanstack-virtual": "static-1.42",
  "stylex-utils": "static-1.164",
  "opentelemetry-web": "static-1.20",
  "beacon-keepalive-queue": "static-1.127",
  "hub-http-shared-msw-handlers": "static-1.10824",
  "hubspotter-http-shared-msw-handlers": "static-1.10822",
  "usage-tracker-session-replay": "static-1.5427",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.507",
  "chirp-fetch": "static-1.2328",
  "chatspot-core": "static-1.23566",
  "copilot-toolkit": "static-1.12063",
  "customer-data-objects-ui-components": "static-1.13457",
  "data-fetching-client": "static-1.10073",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5185",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29522",
  "usage-tracker": "static-1.7741",
  "cms-field-types": "static-1.5239",
  "content-icons-ui": "static-1.2418",
  "integrations-lib": "static-1.17319",
  "customer-data-objects": "static-1.8120",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2026",
  "apollo-link-hub-http": "static-2.5022",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4568",
  "poll-commands": "static-1.3901",
  "ui-addon-iframeable": "static-1.9503",
  "video-components-external": "static-1.12350",
  "video-data-lib": "static-1.36008",
  "breeze-artifacts-sdk": "static-1.716",
  "audio-components": "static-1.6503",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29990",
  "FileManagerImages": "static-1.37910",
  "foundations-components-legacy": "static-1.1699",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.684",
  "ui-universal-auth": "static-1.9639",
  "urlinator": "static-1.4943",
  "video-components": "static-1.14352",
  "video-embed": "static-1.36842",
  "ts-schema": "static-1.4370",
  "ContentData": "static-1.69439",
  "layout-data-lib": "static-1.10446",
  "react-dnd-compat": "static-1.5037",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1973",
  "external-options-client-types": "static-1.4419",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6016",
  "hs-resources": "static-1.624",
  "inbound-db-properties-service-client": "static-1.4117",
  "NamespacedHubStyle": "static-2.9333",
  "growth-onboarding-confetti": "static-1.3490",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11573",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5863",
  "magpie-types": "static-1.5323",
  "simple-logging-lib": "static-1.3478",
  "avatar-components": "static-1.2911",
  "customer-data-ui-utilities": "static-1.10260",
  "growth-onboarding-feedback-components": "static-1.7009",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5305",
  "integrations-error-boundary-lib": "static-1.14734",
  "integrations-tracking-lib": "static-1.6038",
  "laboratory-lib": "static-3.7577",
  "native-integrations-shared-strings": "static-1.8190",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10701",
  "unified-auth": "static-1.1153",
  "breeze-engine-chat-components": "static-1.1004",
  "breeze-engine-core": "static-1.1304",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1068",
  "navigation-messaging": "static-1.8407",
  "content-media-composition-data-lib": "static-1.13501",
  "content-media-compositions": "static-2.17508",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19571",
  "nudge-client-utils": "static-1.3337",
  "unified-auth-core-lib": "static-1.1435",
  "social-insights-client-types": "static-1.22857",
  "advanced-menus-core": "static-1.15743",
  "advanced-menus-lib": "static-1.12514",
  "ExportDialog": "static-6.10798",
  "ui-memberships-settings-lib": "static-1.35098",
  "conditional-properties-service-client": "static-1.4090",
  "crm-pipelines-api-client-types": "static-1.4421",
  "event-emitter": "static-1.1386",
  "framework-builder-read-service-client": "static-1.4299",
  "fdsr-migration-layer": "static-1.438",
  "inbound-db-meta-service-client": "static-1.3748",
  "multi-currency-client-types": "static-1.3986",
  "foundations-components-test-utils": "static-1.6157",
  "reactive-lib": "static-1.1150",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.764",
  "universal-page-editor-lib": "static-1.3436",
  "adobe-sign-auth-lib": "static-1.681",
  "ads-unified-auth-lib": "static-1.1794",
  "custom-vendor-connection-lib": "static-1.203",
  "google-sheets-integration-lib": "static-1.1248",
  "microsoft-drive-auth-lib": "static-1.409",
  "surveymonkey-integration-lib": "static-1.776",
  "slack-ui-library": "static-1.10824",
  "bend-plugin-pulse": "static-1.571",
  "fast-json-patch": "static-1.73",
  "nav-meta": "static-1.30717",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3094",
  "nudge-renderer-utils": "static-1.3413",
  "onboarding-tours": "static-1.17317",
  "whisper-core-api": "static-1.7555",
  "fsm": "static-1.4182",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15742",
  "simple-menus-lib": "static-1.17259",
  "settings-ui-lib": "static-1.12957",
  "persist-promise": "static-1.4130",
  "crm-record-cards-service-types": "static-1.3839",
  "framework-data-schema-resolvers": "static-1.7319",
  "location-customization-utils-lib": "static-1.10334",
  "getting-started-shared-tasks": "static-1.19480",
  "growth-data-modal": "static-1.6064",
  "growth-onboarding-next-action-utils": "static-1.2903",
  "navigation-components": "static-1.19080",
  "onboarding-tours-client": "static-1.5532",
  "onboarding-tours-utils": "static-1.1384",
  "ui-shepherd-tracker": "static-1.8082",
  "user-context": "static-1.5480",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7224",
  "onboarding-data-sync-lib": "static-1.2768",
  "growth-onboarding-next-action-components": "static-1.2931",
  "user-context-client": "static-1.4936",
  "nest": "static-1.663",
  "getting-started-shared-tasks-store": "static-1.18598",
  "InboxConnectUtils": "static-4.15765",
  "meetings-connect-utils-lib": "static-1.8043",
  "onboarding-scopes": "static-1.6879"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30948",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55524",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8465",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11919",
  "I18n": "/I18n/static-7.1696",
  "quartz": "/quartz/static-1.7600",
  "quartz-config": "/quartz-config/static-1.1378",
  "quartz-core": "/quartz-core/static-1.6819",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1049",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55511",
  "feedback-utils": "/feedback-utils/static-1.55515",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4890",
  "forms-utils-lib": "/forms-utils-lib/static-1.13263",
  "foundations-assets": "/foundations-assets/static-1.5312",
  "foundations-components": "/foundations-components/static-1.8674",
  "foundations-theming": "/foundations-theming/static-1.4909",
  "hub-http": "/hub-http/static-1.6636",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12226",
  "icons": "/icons/static-2.699",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4200",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17160",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5632",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "tinymce-plugins": "/tinymce-plugins/static-1.58430",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8865",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3877",
  "quartz-webpack": "/quartz-webpack/static-1.3824",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2625",
  "property-description-translator": "/property-description-translator/static-1.4247",
  "HeadJS": "/HeadJS/static-2.815",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3576",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.23",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4735",
  "jasmine-runner": "/jasmine-runner/static-1.6877",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.214",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.900",
  "hubspotter-http": "/hubspotter-http/static-1.4940",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.598",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.589",
  "quartz-auth": "/quartz-auth/static-1.1275",
  "quartz-head": "/quartz-head/static-1.1265",
  "quartz-i18n": "/quartz-i18n/static-1.1275",
  "quartz-routing": "/quartz-routing/static-1.1030",
  "quartz-test": "/quartz-test/static-1.1275",
  "quartz-tracking": "/quartz-tracking/static-1.979",
  "trellis-components": "/trellis-components/static-1-rdeane_hubspot-tooltip-trigger-canary.14",
  "ui-fonts": "/ui-fonts/static-1.1181",
  "usage-tracker-container": "/usage-tracker-container/static-1.7731",
  "usage-tracker-core": "/usage-tracker-core/static-1.7591",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.315",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8604",
  "sanitize-text": "/sanitize-text/static-1.8583",
  "PatternValidationJS": "/PatternValidationJS/static-1.3313",
  "ReduxMessenger": "/ReduxMessenger/static-2.10798",
  "outpost": "/outpost/static-1.4560",
  "rpc-client-utils": "/rpc-client-utils/static-1.5097",
  "sanitize": "/sanitize/static-1.4900",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4943",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9851",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.94",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1-rdeane_hubspot-tooltip-trigger-canary.14",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3392",
  "foundations-theming-base": "/foundations-theming-base/static-1.3894",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.370",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9941",
  "atom": "/atom/static-1.5504",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8355",
  "ContentUtils": "/ContentUtils/static-1.69364",
  "data-token-picker": "/data-token-picker/static-1.17056",
  "file-manager-components": "/file-manager-components/static-1.24759",
  "FileManagerCore": "/FileManagerCore/static-1.40258",
  "FileManagerLib": "/FileManagerLib/static-1.40399",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8345",
  "hub-http-contrib": "/hub-http-contrib/static-1.3455",
  "interframe": "/interframe/static-3.5167",
  "layout-dnd-components": "/layout-dnd-components/static-1.13146",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12121",
  "property-translator": "/property-translator/static-1.5806",
  "react-codemirror": "/react-codemirror/static-1.11067",
  "react-colorpicker": "/react-colorpicker/static-2.10639",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8533",
  "rich-text-lib": "/rich-text-lib/static-1.20484",
  "tinymce-data": "/tinymce-data/static-1.41401",
  "tinymce-themes": "/tinymce-themes/static-1.57286",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10293",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5629",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16818",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1412",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "stylex-utils": "/stylex-utils/static-1.164",
  "opentelemetry-web": "/opentelemetry-web/static-1.20",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.127",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10824",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10822",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5427",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.507",
  "chirp-fetch": "/chirp-fetch/static-1.2328",
  "chatspot-core": "/chatspot-core/static-1.23566",
  "copilot-toolkit": "/copilot-toolkit/static-1.12063",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13457",
  "data-fetching-client": "/data-fetching-client/static-1.10073",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5185",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29522",
  "usage-tracker": "/usage-tracker/static-1.7741",
  "cms-field-types": "/cms-field-types/static-1.5239",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "integrations-lib": "/integrations-lib/static-1.17319",
  "customer-data-objects": "/customer-data-objects/static-1.8120",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2026",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4568",
  "poll-commands": "/poll-commands/static-1.3901",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9503",
  "video-components-external": "/video-components-external/static-1.12350",
  "video-data-lib": "/video-data-lib/static-1.36008",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.716",
  "audio-components": "/audio-components/static-1.6503",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29990",
  "FileManagerImages": "/FileManagerImages/static-1.37910",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1699",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.684",
  "ui-universal-auth": "/ui-universal-auth/static-1.9639",
  "urlinator": "/urlinator/static-1.4943",
  "video-components": "/video-components/static-1.14352",
  "video-embed": "/video-embed/static-1.36842",
  "ts-schema": "/ts-schema/static-1.4370",
  "ContentData": "/ContentData/static-1.69439",
  "layout-data-lib": "/layout-data-lib/static-1.10446",
  "react-dnd-compat": "/react-dnd-compat/static-1.5037",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1973",
  "external-options-client-types": "/external-options-client-types/static-1.4419",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6016",
  "hs-resources": "/hs-resources/static-1.624",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4117",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9333",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3490",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11573",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5863",
  "magpie-types": "/magpie-types/static-1.5323",
  "simple-logging-lib": "/simple-logging-lib/static-1.3478",
  "avatar-components": "/avatar-components/static-1.2911",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10260",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7009",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5305",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14734",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6038",
  "laboratory-lib": "/laboratory-lib/static-3.7577",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8190",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10701",
  "unified-auth": "/unified-auth/static-1.1153",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1004",
  "breeze-engine-core": "/breeze-engine-core/static-1.1304",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1068",
  "navigation-messaging": "/navigation-messaging/static-1.8407",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13501",
  "content-media-compositions": "/content-media-compositions/static-2.17508",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19571",
  "nudge-client-utils": "/nudge-client-utils/static-1.3337",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1435",
  "social-insights-client-types": "/social-insights-client-types/static-1.22857",
  "advanced-menus-core": "/advanced-menus-core/static-1.15743",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12514",
  "ExportDialog": "/ExportDialog/static-6.10798",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35098",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4090",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4421",
  "event-emitter": "/event-emitter/static-1.1386",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4299",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.438",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3748",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3986",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6157",
  "reactive-lib": "/reactive-lib/static-1.1150",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.764",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3436",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.681",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1794",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.203",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1248",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.409",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.776",
  "slack-ui-library": "/slack-ui-library/static-1.10824",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.571",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "nav-meta": "/nav-meta/static-1.30717",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3094",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3413",
  "onboarding-tours": "/onboarding-tours/static-1.17317",
  "whisper-core-api": "/whisper-core-api/static-1.7555",
  "fsm": "/fsm/static-1.4182",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15742",
  "simple-menus-lib": "/simple-menus-lib/static-1.17259",
  "settings-ui-lib": "/settings-ui-lib/static-1.12957",
  "persist-promise": "/persist-promise/static-1.4130",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3839",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7319",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10334",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19480",
  "growth-data-modal": "/growth-data-modal/static-1.6064",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2903",
  "navigation-components": "/navigation-components/static-1.19080",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5532",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1384",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8082",
  "user-context": "/user-context/static-1.5480",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7224",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2768",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2931",
  "user-context-client": "/user-context-client/static-1.4936",
  "nest": "/nest/static-1.663",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18598",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15765",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8043",
  "onboarding-scopes": "/onboarding-scopes/static-1.6879"
}
};
